import { render } from "./OverViewComponent.vue?vue&type=template&id=31cd5e88"
import script from "./OverViewComponent.vue?vue&type=script&lang=js"
export * from "./OverViewComponent.vue?vue&type=script&lang=js"

import "./OverViewComponent.vue?vue&type=style&index=0&id=31cd5e88&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__